import React from 'react';
import { Link } from 'react-router-dom';
import CelestialLayout from '../components/celestial/CelestialLayout';
import TopNav from '../components/celestial/TopNav';
import SiteFooter from '../components/celestial/SiteFooter';
import MaterialIcon from '../components/celestial/MaterialIcon';

const sections = [
  {
    id: 'astro',
    icon: 'auto_graph',
    watermark: 'flare',
    title: 'Burç haritası ve astroloji',
    items: [
      { label: 'Natal harita (doğum haritası)', text: 'Doğum tarihi, saati ve yerinize göre kişiselleştirilmiş burç haritası oluşturulur. Güneş, Ay, yükselen ve gezegen konumları ile evler hesaplanır; yorumlar yapay zeka ile zenginleştirilir.' },
      { label: 'İlerletilmiş harita ve güneş dönüşü', text: 'Zaman içindeki astrolojik gelişiminizi ve yıllık temaları inceleyebilirsiniz.' },
      { label: 'Sinastri ve uyum haritaları', text: 'İki kişinin haritalarını karşılaştırarak ilişki dinamikleri ve uyum analizi sunulur.' },
    ],
    footer: 'Tüm hesaplamalar Swiss Ephemeris tabanlıdır; sonuçlar profesyonel astroloji standartlarına uygundur.',
  },
  {
    id: 'tarot',
    icon: 'style',
    watermark: 'style',
    title: 'Tarot okumaları',
    items: [
      { label: 'Tek kart çekimi', text: 'Günlük rehberlik veya hızlı bir cevap için tek kart seçilir; anlamı ve yorumu sunulur.' },
      { label: 'Açılımlar (spread)', text: 'Geçmiş–şimdi–gelecek, Keltik haçı ve diğer yaygın açılımlarla daha detaylı okumalar. Kartların konumlarına göre AI ile bağlama özel yorum.' },
      { label: 'Promptlu tarot', text: 'Kendi sorunuzu yazarsınız; sistem uygun kartları seçer ve sorunuza göre yorumlar.' },
    ],
    footer: 'Tarot kartları yüksek çözünürlüklü görsellerle sunulur; çekimler "Kaydedilenler" bölümünden görüntülenebilir.',
  },
  {
    id: 'dashboard',
    icon: 'calendar_month',
    watermark: 'wb_twilight',
    title: 'Dashboard ve günlük içerik',
    items: [
      { label: 'Astrolojik olaylar', text: 'Ay evreleri, gezegen geçişleri, retrolar ve önemli açılar takvim üzerinden; günlük/haftalık özetler.' },
      { label: 'Ay evresi ve bir sonraki olay', text: 'Güncel ay evresi ve yaklaşan önemli tarihler tek bakışta.' },
      { label: 'Olay etkileri ve enerji skorları', text: 'Seçilen tarih veya dönem için genel enerji ve tema yorumları.' },
      { label: 'Retro radar', text: 'Geri hareketteki (retro) gezegenler ve etkileri özetlenir.' },
      { label: 'Günlük tarot / günün mesajı', text: 'Kişiselleştirilmiş günlük kart veya kısa mesaj (abonelik kapsamında).' },
    ],
  },
  {
    id: 'personalization',
    icon: 'person',
    watermark: 'group',
    title: 'Kişiselleştirme ve kayıtlar',
    items: [
      { label: 'Profil ve doğum bilgileri', text: 'Birden fazla kişi (astro kişisi) ekleyebilir; her biri için doğum bilgilerini saklayıp harita ve yorumları kişi bazında kullanabilirsiniz.' },
      { label: 'Kaydedilen okumalar', text: 'Tarot çekimleri ve astroloji yorumları "Kaydedilenler"e eklenir; listeleme, filtreleme ve silme seçenekleri.' },
      { label: 'Bildirimler', text: 'Önemli astrolojik olaylar ve uygulama güncellemeleri için isteğe bağlı push bildirimleri.' },
    ],
  },
  {
    id: 'plans',
    icon: 'stars',
    watermark: 'workspace_premium',
    title: 'Ücretsiz sürüm ve Astro Plus',
    items: [
      { label: 'Ücretsiz sürüm', text: 'Aylık belirli sayıda burç haritası ve günlük belirli sayıda tarot okuması hakkı. Kaydedilen okuma ve astro kişisi sayısı sınırlıdır.' },
      { label: 'Astro Plus', text: 'Daha yüksek limitler, tüm harita tipleri ve açılımlar, günlük kişiselleştirilmiş içerikler ve gelişmiş dashboard. Abonelik Google Play ve App Store üzerinden yönetilir.' },
    ],
  },
];

export default function ContentDetail() {
  return (
    <CelestialLayout>
      <TopNav />
      <main className="celestial-main celestial-section-pad">
        <div className="celestial-container">
          <header className="celestial-content-hero">
            <h1 className="celestial-display celestial-gradient-text" style={{ fontSize: 'clamp(2rem, 5vw, 3rem)' }}>
              İçerikler ve Özellikler
            </h1>
            <p className="celestial-body-lg">
              Astro Social uygulamasında sunulan astroloji, tarot ve kişiselleştirilmiş içerikler
              hakkında detaylı bilgi.
            </p>
          </header>

          <div className="celestial-content-grid">
            {sections.map((section) => (
              <article key={section.id} className="celestial-glass celestial-content-card">
                <div className="celestial-content-card__watermark" aria-hidden>
                  <MaterialIcon name={section.watermark} size={120} />
                </div>
                <div className="celestial-content-card__header">
                  <div className="celestial-icon-box" style={{ borderRadius: '999px' }}>
                    <MaterialIcon name={section.icon} />
                  </div>
                  <h2 className="celestial-headline-lg" style={{ margin: 0 }}>
                    {section.title}
                  </h2>
                </div>
                {section.items.map((item, idx) => (
                  <React.Fragment key={item.label}>
                    {idx > 0 && <hr className="celestial-content-divider" />}
                    <div className="celestial-content-item">
                      <h3>{item.label}</h3>
                      <p>{item.text}</p>
                    </div>
                  </React.Fragment>
                ))}
                {section.footer && (
                  <p className="celestial-content-footer-note">
                    <MaterialIcon name="verified" size={16} />
                    {section.footer}
                  </p>
                )}
              </article>
            ))}
          </div>

          <p className="celestial-text-center" style={{ marginTop: '3rem' }}>
            <Link to="/" className="celestial-btn-secondary">
              <MaterialIcon name="arrow_back" size={18} />
              Ana sayfaya dön
            </Link>
          </p>
        </div>
      </main>
      <SiteFooter />
    </CelestialLayout>
  );
}
